import { render, staticRenderFns } from "./AFormLabel.vue?vue&type=template&id=160036c1&scoped=true&"
import script from "./AFormLabel.vue?vue&type=script&lang=js&"
export * from "./AFormLabel.vue?vue&type=script&lang=js&"
import style0 from "./AFormLabel.vue?vue&type=style&index=0&id=160036c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160036c1",
  null
  
)

export default component.exports